import { render, staticRenderFns } from "./Home.html?vue&type=template&id=2185fdc0&scoped=true&external"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.scss?vue&type=style&index=0&id=2185fdc0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2185fdc0",
  null
  
)

export default component.exports